import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "navbar navbar-expand-lg fixed-top" }
const _hoisted_2 = ["href", "target"]
const _hoisted_3 = {
  key: 0,
  class: "cuscd-brand-logo-img-wrap"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 0,
  class: "cuscd-alert-count",
  id: "alertBadge"
}
const _hoisted_6 = { class: "navbar-nav mr-auto cuscd-right-side" }
const _hoisted_7 = {
  key: 0,
  class: "nav-item active cuscd-title-bar"
}
const _hoisted_8 = { class: "nav-link" }
const _hoisted_9 = {
  key: 0,
  class: "cuscd-h1style"
}
const _hoisted_10 = {
  key: 1,
  class: "nav-item cuscd-solid-wrap"
}
const _hoisted_11 = {
  key: 2,
  class: "nav-item cuscd-solid-wrap"
}
const _hoisted_12 = {
  key: 3,
  class: "nav-item cuscd-solid-wrap"
}
const _hoisted_13 = {
  key: 4,
  class: "nav-item cuscd-solid-wrap"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_LogoutModal = _resolveComponent("LogoutModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("a", {
        class: "navbar-brand",
        href: _ctx.lenderData ? _ctx.lenderData.lenderWebsiteUrl : '#',
        target: _ctx.externalLinks ? '_blank' : undefined
      }, [
        (_ctx.cuLogoUrl)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
              _createElementVNode("img", {
                src: _ctx.cuLogoUrl,
                alt: "Logo",
                class: "icon-banner"
              }, null, 8, _hoisted_4)
            ]))
          : _createCommentVNode("", true)
      ], 8, _hoisted_2),
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
          _createElementVNode("span", { class: "cuscd-brand-logo-name" }, "SLC Applicant Portal", -1)
        ]))]),
        _: 1
      }),
      _createElementVNode("button", {
        type: "button",
        class: "navbar-toggler",
        "aria-label": "Toggle navigation",
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.toggleSidenav(true)), ["prevent"]))
      }, [...(_cache[7] || (_cache[7] = [
        _createElementVNode("span", { class: "navbar-toggler-icon" }, null, -1)
      ]))]),
      _createElementVNode("a", {
        class: "cuscd-notify-alert-mobile",
        title: "Notifications",
        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.showModal = true), ["prevent"]))
      }, [
        _cache[8] || (_cache[8] = _createElementVNode("span", { class: "sr-only" }, "Notifications", -1)),
        (_ctx.notificationCount > 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.notificationCount), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["collapse navbar-collapse", { show: _ctx.sidenavActive, collapsed: !_ctx.sidenavActive }])
      }, [
        _createElementVNode("ul", _hoisted_6, [
          (_ctx.oidcIsAuthenticated)
            ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, [
                  _cache[9] || (_cache[9] = _createElementVNode("span", { class: "cuscd-small-title" }, "Welcome", -1)),
                  (_ctx.oidcIsAuthenticated)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.decodeHTMLEncodedStr(_ctx.formatName(_ctx.oidcUser.nickname?.toLowerCase()))), 1))
                    : _createCommentVNode("", true),
                  _cache[10] || (_cache[10] = _createElementVNode("span", { class: "sr-only" }, "(current)", -1)),
                  _createElementVNode("a", {
                    href: "",
                    class: "close-btn",
                    "aria-label": "Close",
                    onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.toggleSidenav(false)), ["prevent"]))
                  }, "   ")
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.oidcIsAuthenticated)
            ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                (_ctx.route.params.referenceId)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: {name: 'ApplicationDocuments', params: { referenceId: `${_ctx.route.params.referenceId}`}},
                      class: "nav-link cuscd-mysummary"
                    }, {
                      default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                        _createTextVNode(" My Documents ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["to"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.oidcIsAuthenticated)
            ? (_openBlock(), _createElementBlock("li", _hoisted_11, [
                _createVNode(_component_router_link, {
                  to: "/",
                  class: "nav-link cuscd-mysummary"
                }, {
                  default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                    _createTextVNode(" My Apps ", -1)
                  ]))]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.oidcIsAuthenticated)
            ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
                _createElementVNode("a", {
                  href: "",
                  class: "nav-link cuscd-logout",
                  onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.showLogoutModal = true), ["prevent"]))
                }, " Logout ")
              ]))
            : _createCommentVNode("", true),
          (!_ctx.oidcIsAuthenticated)
            ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
                _createElementVNode("a", {
                  href: "",
                  class: "nav-link cuscd-logout",
                  onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)), ["prevent"]))
                }, " Login ")
              ]))
            : _createCommentVNode("", true)
        ])
      ], 2)
    ]),
    (_ctx.showLogoutModal)
      ? (_openBlock(), _createBlock(_component_LogoutModal, {
          key: 0,
          onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showLogoutModal = false))
        }))
      : _createCommentVNode("", true)
  ], 64))
}